export default class MemberDetailsAbstractServices {
  static getMemberDetailsPageReferenceData() {
    logger.error('MemberDetails:: getMemberDetailsPageReferenceData() not implemented');
  }

  static getMemberDetails() {
    logger.error('MemberDetails:: getMemberDetails() not implemented');
  }

  static postMemberDetails() {
    logger.error('MemberDetails:: postMemberDetails() not implemented');
  }

  static getMemberships() {
    logger.error('MemberDetails:: getMemberDetails() not implemented');
  }

  static getMembers() {
    logger.error('MemberDetails:: getMembers() not implemented');
  }

  static getMemberSelectionContents() {
    logger.error('MemberDetails:: getMemberSelectionContents() not implemented');
  }

  static getNoImpactPageReferenceData() {
    logger.error('MemberDetails:: getNoImpactPageReferenceData() not implemented');
  }

  static getPremiumImpactPageReferenceData() {
    logger.error('MemberDetails:: getPremiumImpactPageReferenceData() not implemented');
  }

  static getCoverDetails() {
    logger.error('MemberDetails:: getCoverDetails() not implemented');
  }

  static getMemberPolicies() {
    logger.error('MemberDetails:: getMemberPolicies() not implemented');
  }
}
